<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2021-12-10 14:01:22
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2022-03-18 15:55:52
-->
<template>
  <div class="content">
    <div class="title-wrap">
      <div class="con">
        <img class="logo" src="~@/assets/logo_login.png" alt="" />
        <h2 class="title">乡村振兴数字化管理平台</h2>
      </div>
    </div>
    <div class="info-wrap">
      <div class="info">
        <div class="left-side">
          <img src="@/assets/icon_login.png" alt="" />
        </div>
        <div class="right-side">
          <h2 class="tit">欢迎登录</h2>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="0"
          >
            <el-form-item label="" prop="loginName">
              <div class="lable"><i class="iconfont icon-yonghuming"></i></div>
              <el-input
                v-model="ruleForm.loginName"
                placeholder="请输入用户名"
              ></el-input>
            </el-form-item>
            <el-form-item label="" prop="password">
              <div class="lable"><i class="iconfont icon-denglumima"></i></div>
              <el-input
                type="password"
                v-model="ruleForm.password"
                autocomplete="off"
                placeholder="请输入密码"
                @keyup.enter.native="handleSubmitInfo('ruleForm')"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                :disabled="submitFlag"
                @click="handleSubmitInfo('ruleForm')"
                >登录</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="foot">
      技术服务：金色大田科技有限公司
      <a href="https://beian.miit.gov.cn" target="_blank">
        京ICP备14027879号-23
      </a>
      <a href="http://www.beian.gov.cn" target="_blank">
        京公网安备11010802038807号
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "Login",
  data() {
    return {
      ruleForm: {
        loginName: "",
        password: "",
      },
      rules: {
        loginName: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      submitFlag: false,
    };
  },
  methods: {
    ...mapActions(["getAccesToken"]),
    /**
     * @descripttion: 提交信息
     * @Author: juanjuanhui
     * @Date: 2021-12-10 14:31:15
     * @param {*} formName
     */
    handleSubmitInfo(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitFlag = true;
          this.$http.login
            .login({ ...this.ruleForm }, "application/x-www-form-urlencoded")
            .then((res) => {
              console.log(res.data);
              localStorage.setItem("user", JSON.stringify(res.data));
              localStorage.setItem("loginTime", new Date().getTime());
              localStorage.setItem("accessToken", res.data.accessToken);
              this.getAccesToken(res.data.accessToken);
              this.$message.success("登录成功");
              this.$router.push({ path: "/" });
            })
            .catch((err) => {
              console.log(err);
              this.submitFlag = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  min-height: 100%;

  .title-wrap {
    height: 6vw;
    background: #fff;
    .con {
      display: flex;
      align-items: center;
      width: 70vw;
      height: 100%;
      margin: 0 auto;
    }
    .logo {
      width: 2.6vw;
      height: 3.91vw;
      margin-right: 10px;
    }
    .title {
      color: #333333;
      font-size: 2.81vw;
    }
  }
  .info-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    min-height: 38.44vw;
    background: url("~@/assets/login_bg.jpg") no-repeat center 100% #05bec8;
    .info {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      width: 70vw;
      .left-side {
        width: 31vw;
        margin-top: 2vw;
        img {
          max-width: 100%;
        }
      }
      .right-side {
        width: 28vw;
        max-width: 540px;
        padding: 2vw;
        box-sizing: border-box;
        background-color: #ffffff;
        border-radius: 1vw;
        .tit {
          padding-bottom: 2vw;
          font-size: 2vw;
          color: #242424;
        }
        ::v-deep {
          .el-form-item {
            margin-bottom: 2vw;
            &:not(:last-child) {
              .el-form-item__content {
                display: flex;
                align-items: center;
                height: 4vw;
                line-height: 4vw;
                font-size: 1.3vw;
                box-sizing: border-box;
                background: #f3f3f3;
                .lable {
                  position: relative;
                  padding: 0 15px;
                  color: #bbb;
                  display: flex;
                  align-items: center;
                  .iconfont {
                    font-size: 30px;
                  }
                  &::after {
                    position: absolute;
                    top: 50%;
                    right: 0;
                    transform: translateY(-50%);
                    content: "";
                    width: 1px;
                    height: 26px;
                    background-color: #e2e2e2;
                  }
                }
                .el-input {
                  height: 100%;
                  .el-input__inner {
                    height: 100%;
                    border: none;
                    background-color: #f3f3f3;
                  }
                }
                .el-form-item__error {
                  position: absolute;
                  float: none;
                  padding-top: 4px;
                  font-size: 14px;
                  line-height: normal;
                  padding-left: 0;
                }
              }
            }
            .el-button {
              width: 100%;
              height: 4.6vw;
              padding: 0;
              border: none;
              font-size: 1.5vw;
              color: #ffffff;
              background-image: linear-gradient(90deg, #009298 0%, #00afb6 100%),
                linear-gradient(#0074e6, #0074e6);
              background-blend-mode: normal, normal;
              border-radius: 2.3vw;
              box-sizing: border-box;
            }
          }
        }
      }
    }
  }
  .foot {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px 0;
    font-size: 1.1vw;
    color: #999999;
    a {
      color: #999999;
      margin-left: 10px;
    }
  }
}
</style>
<style>
input:-internal-autofill-selected {
  box-shadow: 0 0 0 1000px #f3f3f3 inset !important;
}
</style>
